import { toastError } from "../../../commons/utils";
import { IContext } from "../../../contexts/AuthProvider/types";

export async function getTipoMovStatus(auth: IContext, tipmovcontador: number) {
    try {
        const response: any = await auth.get('/v1/tipomovimentostatuscrm?tipmovcontador=' + tipmovcontador);
        const filteredData = response.data
            .filter((item: any) => item.tipmovstativo === 1)
            .sort((a: any, b: any) => (a.tipmovstsequencia - b.tipmovstsequencia));

        const _status = filteredData
            .map((item: any) => ({
                id: item.tipmovstid,
                title: item.tipmovstdescricao,
                color: item.tipmovstcor ? (item.tipmovstcor.length >= 9 ? item.tipmovstcor.slice(0, -2) : item.tipmovstcor) : '',
                value: item.tipmovstid,
                sequencia: item.tipmovstsequencia
            }));

        return _status;
    } catch (error: any) {
        toastError(error);
    }
}